import {
  AdminDocsHostProvider,
  DocsRoute,
  type AdminDocsHost,
} from '@tiaki/admin-docs';
import { usePermissions } from '@aegix/auth-permissions';
import { usePageTitle } from '../hooks/usePageTitle';

const resolveDocUrl = (slug: string) => `/account/docs/${slug}`;

export function AdminDocs() {
  usePageTitle('Admin Guides');
  const permissions = usePermissions();
  // `@tiaki/admin-docs`'s `AdminDocsHost` expects a mutable `string[]`;
  // the lib hands back `readonly string[]` to discourage in-place
  // mutation. Take a defensive copy at the boundary rather than
  // loosening the lib's contract.
  const host: AdminDocsHost = {
    permissions: [...permissions],
    resolveDocUrl,
  };
  return (
    <AdminDocsHostProvider host={host}>
      <DocsRoute />
    </AdminDocsHostProvider>
  );
}

export default AdminDocs;
